export const containsLowerLetter = input => /[a-z]/.test(input)

export const containsUpperLetter = input => /[A-Z]/.test(input)

export const containsNumber = input => /\d/.test(input)

export const containsSpecialCharacters = input => /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(input)

export const checkPasswordStrength = (value) => {
  return [
    { valid: containsSpecialCharacters(value) },
    { valid: containsUpperLetter(value) },
    { valid: containsLowerLetter(value) },
    { valid: containsNumber(value) }
  ]
}